module.exports = __webpack_public_path__ + "static/media/starburst.netent.7ac42048.jpeg";